<template>
  <div class="condition-edit">
    <div class="condition-edit-content">
		<div class="content-select">
			<div class="select-top">
				<div class="select-opt" v-if="option">
					<el-dropdown @command="handleCommandChange" class="exclude-drop"  trigger="click" placement="bottom-start">
						<span class="dropdown-icon">
							<span v-if="formData.isExclude" class="icon iconfont icon-jt-paichu text-color-error" title="排除"></span>
							<span v-else class="icon iconfont icon-jt-invert-full active-icon" title="包含"></span>
						</span>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item command="contain"><span  class="icon iconfont icon-jt-invert-full ver-middle" style="color:#409eff"></span> 包含</el-dropdown-item>
							<el-dropdown-item command="exclude" class="text-color-error"><span class="icon iconfont icon-jt-paichu ver-middle"></span> 排除</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
					<span 
						v-if="isPage" 
						class="copy-btn-icon el-icon-document-copy active-icon"  
						title="批量选择" 
						@click="handleBatchSelectData"
					/>
				</div>
				<el-input 
					v-model="keyword"  
					@input="handleInputSearch" 
					:autofocus="true" 
					clearable 
					placeholder="请输入查询关键字"
				/>
			</div>
			<!--  -->
			<div class="select-list"
				v-loading="loading && !list.length"
				v-infinite-scroll="infiniteScrollLoad" 
				:infinite-scroll-distance='30'
				:infinite-scroll-disabled="allData || loading || !isPage"
				:infinite-scroll-immediate='false'
			>
				<div v-if="!listData.length" class="tac font14px pt8">暂无数据</div>
				<div v-else class="select-list-item">
					<el-checkbox 
						:value="isCheckAll" 
						@input="(check)=>handleCheckChange(check, listData)"
					>
						全选
					</el-checkbox>
				</div>
				<div v-for="item in  listData" :key="item.id" class="select-list-item">
					<el-checkbox 
						:value="checkIds.includes(item.id)" 
						@input="(check)=>handleCheckChange(check, item)"
					>
						{{ item.name }}
					</el-checkbox>
				</div>
				<div class="tac font14px text-color-gray" v-show="loading && list.length">数据加载中...</div>
				<div class="tac font14px text-color-gray" v-if="isPage&&allData && listData.length &&!keyword.length">没有更多了</div>
			</div>
		</div>
		<div class="content-result">
			<div class="result-top">
				<span class="check">已选条件（{{checkList.length}}）</span>
				<span class="text-color-error pointer"   @click="()=>handleCheckChange(false, checkList)">清空</span>
			</div>
			<div class="result-list">
				<div v-if="!checkList.length" class="tac font14px pt8">暂无数据</div>
				<div 
					class="result-list-item"
					v-for="item in checkList"
					:key="item.id"
				>
					<span class="text font12px">{{item.name}}</span>
					<span class="del-icon pointer text-color-error pt4" @click="()=>handleCheckChange(false, item)">x</span>
				</div>
			</div>
		</div>
    </div>
  </div>
</template>

<script>
import { InfiniteScroll } from 'element-ui'
import { throttle, debounce } from 'lodash'
import VirtualList from 'vue-virtual-scroll-list'

export default {
	components: { VirtualList  },
	directives: { InfiniteScroll },
	props: {
		loading: {
			type: Boolean,
			default: false
		},
		defaultData: Object,
		loadData: {
			type: Function,
			default: ()=>{}
		},
		list: {},
		dimension: {
			type: Object,
			default: ()=>({})
		},
		batchSelectData: Function,
		option: {
			type: Boolean,
			default: true
		},
		allData: Boolean
	},
    data() {
		const defaultData = this.defaultData || {};
		return {
			disabled: false,
			keyword: '',
			formData: {
				isExclude: defaultData.isExclude || false
			},
			checkList: defaultData.list || []
		}
    },
	computed: {
		checkIds() {
			return this.checkList.map(v=>v.id)
		},
		isPage() {
			return this.dimension.config?.page
		},
		filterList() {
			return this.list.filter(item=> {
				return item.name.indexOf(this.keyword) > -1
			})
		},
		listData() {
			return this.isPage?this.list:this.filterList
		},
		isCheckAll() {
			return this.listData.every(item=> {
				return this.checkIds.includes(item.id)
			})
		}
	},
	mounted() {
		if (!this.isPage) {
			this.infiniteScrollLoad()
		}
	},
	methods: {
		async handleBatchSelectData() {
			this.batchSelectData((list)=>{
				this.handleCheckChange(true, list)
			})
		},
		infiniteScrollLoad() {
			const params = {
				search: this.keyword,
			}
			this.loadData(params)
		},
		handleInputSearch: debounce(function() {
			if (this.isPage) {
				this.$emit('update:list', []);
				this.$emit('update:allData', false);
				this.infiniteScrollLoad()
			}
		}, 200),
		handleCommandChange(name) {
			this.formData.isExclude = name === 'exclude'
		},
		handleCheckChange(check, data) {
			if (!Array.isArray(data)) {
				data = [ data ];
			};
			if (check) {
				const filterList = data.filter(v=>!this.checkIds.includes(v.id));
				this.checkList = [].concat(filterList, this.checkList);
			}else {
				const ids = data.map(v=>v.id);
				this.checkList = this.checkList.filter(v=>!ids.includes(v.id))
			}
		},
		async getFormData() {
			return {
				...this.formData,
				list: this.checkList
			}
		}
	},
}
</script>

<style lang="scss" scoped>
.condition-edit-content {
  border: 1px solid #ccc;
  height: 300px;
  display: flex;
  justify-content: space-between;
  .content-select,.content-result {
	width: 0;
    flex: 1 1 0;
    height: 100%;
	display: flex;
	flex-direction: column;
  }
  .content-select {
    border-right: 1px solid #ccc;
	padding: 10px;
	.select-top {
		display: flex;
		align-items: center;
		.dropdown-icon {
			cursor: pointer;
		}
		.select-opt {
			margin-right: 12px;
			display: flex;
			align-items: center;
			.copy-btn-icon {
				font-size: 20px;
				padding-left: 10px;
			}
		}
		.active-icon{
			color: #409eff !important;
		}
		.ver-middle{
			vertical-align: middle;
		}
	}
	.select-list {
		flex: 1 1 0;
		overflow-x: auto;
    	overflow-y: auto;
		padding: 10px 8px 0;
	}
  }
	.content-result {
		padding: 10px;
		.result-top {
			font-size: 12px;
			display: flex;
			justify-content: space-between;
			font-weight: bold;
			padding-right: 6px;
			.check {
				color: #606266;
			}
		}
		.result-list {
			flex: 1 1 0;
			overflow-x: auto;
    		overflow-y: auto;
			margin-top: 6px;
			padding-right: 6px;
			&-item {
				display: flex;
				justify-content: space-between;
				padding-left: 10px;
				.text {
					padding: 4px 0;
				}
			}
			.del-icon {
				font-size: 12px;
			}
		}
	}
  
}
</style>